import styled from "styled-components"
import { device } from "breakpoints"

export const ImgRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px auto 20px;


  @media ${device.tablet} {
    flex-direction: row;

  }


  @media ${device.desktop} {
    width: 75%;
    margin: 25px auto 63px 0;
  }
`

export const ImageWrapper = styled.div`
  ${"" /* padding-top: 47.4%; */}
  flex-basis: 100%;
  position: relative;
  margin-bottom: 15px;

  @media ${device.tablet} {
    margin-bottom: 0;
    flex-basis: 50%;
  }
  @media ${device.tablet} {
    margin: 0 14px;

  }
  :first-of-type {
    @media ${device.tablet} {
      margin-right: 14px;
      margin-left: 0;
    }
  }

  :last-of-type {
    @media ${device.tablet} {
      margin-left: 14px;
      margin-right: 0;
    }
  }

  h3 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .avenueImg {
    ${"" /* position: absolute !important; */}
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
`
